import styled from 'styled-components';
import { ButtonAction, Styles } from '@honeycomb-npm/honeycomb-react';

type Props = {
    isActive: boolean;
}

export const ModifiedButtonAction = styled(ButtonAction)<Props>`
    &&& {
        max-width: 100%;
        ${(props) => (props.$isActive && ({
        background: Styles.Colors.Aliases.backgroundDark,
        color: Styles.Colors.Aliases.textLight,
    }))}
    }
`;
